import React from 'react';

const Topics = React.lazy(() =>
  import(/* webpackChunkName: "documents-topics" */ '../pages/master/FaqTopics')
);

const Faqs = React.lazy(() =>
  import(/* webpackChunkName: "documents-config" */ '../pages/master/Faqs')
);

const CreateNewFaqTopic = React.lazy(() =>
  import(
    /* webpackChunkName: "documents-topic-create" */ '../pages/master/CreateNewFaqTopic'
  )
);

const FaqTopicsEdit = React.lazy(() =>
  import(
    /* webpackChunkName: "documents-topic-edit" */ '../pages/master/FaqTopicsEdit'
  )
);

const CreateNewFaq = React.lazy(() =>
  import(
    /* webpackChunkName: "documents-create" */ '../pages/master/CreateNewFaq'
  )
);

const FaqsEdit = React.lazy(() =>
  import(/* webpackChunkName: "documents-edit" */ '../pages/master/FaqsEdit')
);

export default [
  {
    id: 'documents-topics',
    path: '/document-topics',
    name: 'Documents',
    component: Topics,
    exact: true,
  },
  {
    id: 'create-new-document-topic',
    path: '/create/document-topic',
    name: 'Create New Topic',
    component: CreateNewFaqTopic,
    excludeFromSidebar: true,
  },
  {
    id: 'documents-topic-edit',
    path: '/document-topics/:id',
    name: 'Topic Edit',
    component: FaqTopicsEdit,
    excludeFromSidebar: true,
  },
  {
    id: 'documents-documents',
    path: '/document-topic/:id/documents-list',
    name: 'Documents List',
    component: Faqs,
    exact: true,
    excludeFromSidebar: true,
  },
  {
    id: 'create-new-document',
    path: '/create/document',
    name: 'Create New Documents',
    component: CreateNewFaq,
    excludeFromSidebar: true,
  },
  {
    id: 'documents-edit',
    path: '/documents-list/:id',
    name: 'Documents Edit',
    component: FaqsEdit,
    excludeFromSidebar: true,
  },
];
